import { render, staticRenderFns } from "./ExtractOfferDetailsV2.vue?vue&type=template&id=5b3e6e82&scoped=true&"
import script from "./ExtractOfferDetailsV2.vue?vue&type=script&lang=js&"
export * from "./ExtractOfferDetailsV2.vue?vue&type=script&lang=js&"
import style0 from "./ExtractOfferDetailsV2.vue?vue&type=style&index=0&id=5b3e6e82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3e6e82",
  null
  
)

export default component.exports